import { queryOptions, useQuery } from "@tanstack/react-query"
import { eiKeys } from "../model/keys"
import {
	getEiLeaderboard,
	getEiProfile,
	getEiResult,
	getEiSession,
} from "./client"

export function eiProfileQueryOptions(userId: number) {
	return queryOptions({
		queryKey: eiKeys.profile(userId),
		queryFn: () => getEiProfile(userId),
		staleTime: 5 * 60 * 1000,
	})
}

export function eiResultQueryOptions() {
	return queryOptions({
		queryKey: eiKeys.result(),
		queryFn: getEiResult,
		staleTime: Number.POSITIVE_INFINITY,
	})
}

export function eiSessionQueryOptions() {
	return queryOptions({
		queryKey: eiKeys.test(),
		queryFn: getEiSession,
		staleTime: Number.POSITIVE_INFINITY,
	})
}

export function useEiProfile(userId: number) {
	return useQuery(eiProfileQueryOptions(userId))
}

export function useEiResult() {
	return useQuery(eiResultQueryOptions())
}

export function useEiSession() {
	return useQuery(eiSessionQueryOptions())
}

export function useEiLeaderboard(highlightUserId?: number) {
	return useQuery({
		queryKey: eiKeys.leaderboard(highlightUserId),
		queryFn: () => getEiLeaderboard(highlightUserId),
		staleTime: 5 * 60 * 1000,
	})
}
